import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueChatScroll from 'vue-chat-scroll'


Vue.use(VueChatScroll)
Vue.use(ElementUI);

Vue.directive('title', {
  inserted: function (el, binding) {
    // console.log(this.$route.params.id)
    document.title = el.dataset.title
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
